import { render, staticRenderFns } from "./ProfilesTable.vue?vue&type=template&id=6ccaf2e0&scoped=true&"
import script from "./ProfilesTable.vue?vue&type=script&lang=ts&"
export * from "./ProfilesTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilesTable.vue?vue&type=style&index=0&id=6ccaf2e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccaf2e0",
  null
  
)

export default component.exports